import type { NavigateOptions } from "react-router";
import type { AssetsView } from "./AssetsViewToggle.types";

/** Assets panel view (?assets-view=). Absent = `ASSETS_VIEW_DEFAULT`; the default is never written. */
export const ASSETS_VIEW_SEARCH_PARAM = "assets-view" as const;

export const ASSETS_VIEW_DEFAULT: AssetsView = "tree";

/** Module constant: `useSearchParamState` captures its options on first render. */
export const ASSETS_VIEW_NAVIGATE_OPTIONS: NavigateOptions = { replace: true };
